import React, { useMemo, useState, useEffect, useCallback } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import { Table } from "../../../Components/Table/Table";
import toast from "react-hot-toast";

import {
  markSalaryPaid,
  getSalaryList,
  deleteSalary
} from "../../../api/salary";
const AllEmployeeSalary = () => {
  const [pageno, setPageno] = useState(1);
  const [data, setData] = useState([]);


  const fetchSalary = async (searchId = "") => {
    try {
      const res = await getSalaryList(
        searchId ? { employeeId: searchId } : {}
      );

      const list = res.data.data;

      if (!list.length) {
        toast("No salary records found ⚠️");
      }

      const currentMonth = new Date().toLocaleString("default", { month: "long" });
      const currentYear = new Date().getFullYear().toString();

      const grouped = {};

      list.forEach((item) => {
        if (!grouped[item.employeeId]) {
          grouped[item.employeeId] = {
            employeeId: item.employeeId,
            employeeName: item.employeeName,
            dateofjoining: item.dateofjoining,
            totalSalary: 0,
            totalMonthsPaid: 0,
            currentMonthStatus: "Pending",
          };
        }

        if (item.status === "Credited") {
          grouped[item.employeeId].totalSalary += item.amount;
          grouped[item.employeeId].totalMonthsPaid += 1;
        }

        if (
          item.month === currentMonth &&
          item.year === currentYear
        ) {
          grouped[item.employeeId].currentMonthStatus = item.status;
        }
      });

      const finalData = Object.values(grouped).map((item, index) => ({
        ...item,
        sno: index + 1,
      }));

      setData(finalData);

    } catch (err) {
      toast.error("Failed to fetch salary data ❌");
    }
  };
  useEffect(() => {
    fetchSalary();
  }, []);

  useEffect(() => {
    const unpaid = data.filter(
      (d) => d.currentMonthStatus !== "Credited"
    );

    if (unpaid.length > 0) {
      toast.error(`⚠️ ${unpaid.length} employees not paid this month`);
    }
  }, [data]);
  const handleDelete = useCallback(async (id) => {
    if (!window.confirm("Are you sure?")) return;

    try {
      await deleteSalary(id);

      toast.success("Salary deleted successfully 🗑️");
      fetchSalary();

    } catch (err) {
      toast.error("Delete failed ❌");
    }
  }, []);

  const handleMarkPaid = useCallback(async (row) => {
    try {
      await markSalaryPaid({
        employeeId: row.employeeId,
        month: row.month,
        year: row.year,
      });

      toast.success("Salary credited successfully 💰");
      fetchSalary();

    } catch (err) {
      toast.error("Error updating salary ❌");
    }
  }, []);
  // ✅ CALCULATIONS

  const totalEmployees = data.length;

  const totalMonthsPaid = data.reduce(
    (sum, item) => sum + item.totalMonthsPaid,
    0
  );

  // ✅ CURRENT MONTH PAID
  const currentMonthPaid = data.filter(
    (item) => item.currentMonthStatus === "Credited"
  ).length;

  // ❌ NOT PAID THIS MONTH
  const pendingMonthsPaid = data.filter(
    (item) => item.currentMonthStatus !== "Credited"
  ).length;


  /* ================= COLUMNS ================= */
  const columns = useMemo(
    () => [
      { Header: "S.No", accessor: "sno" },
      { Header: "Emp ID", accessor: "employeeId" },
      { Header: "Name", accessor: "employeeName" },
      { Header: "Joining Date", accessor: "dateofjoining" },
      { Header: "Months Paid", accessor: "totalMonthsPaid" },
      { Header: "Total Salary", accessor: "totalSalary" },

      {
        Header: "This Month Status",
        Cell: ({ row }) => {
          const status = row.original.currentMonthStatus;

          return (
            <span
              style={{
                padding: "6px 12px",
                borderRadius: "8px",
                color: "#fff",
                background: status === "Credited" ? "green" : "red",
              }}
            >
              {status === "Credited" ? "Paid" : "Not Paid"}
            </span>
          );
        },
      },

      // 🔥 NEW ACTION COLUMN
      {
        Header: "Actions",
        Cell: ({ row }) => (
          <div style={{ display: "flex", gap: "10px" }}>
            {/* MARK PAID */}
            <button
              className="btn22 "
              onClick={() => handleMarkPaid(row.original)}
            >
              Pay
            </button>

            {/* DELETE */}
            <DeleteIcon
              style={{ cursor: "pointer", color: "red" }}
              onClick={() => handleDelete(row.original._id)}
            />
          </div>
        ),
      },
    ],
    [handleDelete, handleMarkPaid]
  );
  return (
    <div className="p-3 mt-3">

      {/* HEADER */}
      <div className="d-flex justify-content-between mb-3">
        <h3>Salary List</h3>

      </div>
      <div className="stats-grid">

        <div className="stat-card stat-default">
          <h6>Total Employees</h6>
          <h3>{totalEmployees}</h3>
        </div>

        <div className="stat-card stat-success">
          <h6>Total Paid Months</h6>
          <h3>{totalMonthsPaid}</h3>
        </div>

        <div className="stat-card stat-primary">
          <h6>Paid This Month</h6>
          <h3>{currentMonthPaid}</h3>
        </div>

        <div className="stat-card stat-danger">
          <h6>Not Paid This Month</h6>
          <h3>{pendingMonthsPaid}</h3>
        </div>

      </div>

      {/* TABLE */}
      <Table
        columns={columns}
        data={data}
        pageno={pageno}
        setPageno={setPageno}
        show
        rowClassName={(row) =>
          row.currentMonthStatus !== "Credited"
            ? "table-danger"   // 🔴 RED ROW
            : "table-success"  // 🟢 GREEN ROW
        }
      />
    </div>
  );
};

export default AllEmployeeSalary